export enum MultiSelectFilterType {
  Text,
  MultiSelectItem
}
